import { render } from "./SpecialProjectsList.vue?vue&type=template&id=54d2c860"
import script from "./SpecialProjectsList.vue?vue&type=script&lang=js"
export * from "./SpecialProjectsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__